import React from "react";

import { CTAButtonV2 } from '../../components/ctabutton';

import { convertPadding } from "../../utils/paddings";
import { getLanguageField } from "../../utils/language";
import type { SolidColorBackgroundProps } from "./types";
import { ModuleHeadV2 } from "src/components/moduleHead/moduleHead.v2";

export default class SolidColorBackground extends React.Component<SolidColorBackgroundProps> {
  get paddingtop() {
    const padding =  convertPadding(this.props.item.padding_top, 'top');
    return padding;
  }
  get paddingbottom() {
    const padding =  convertPadding(this.props.item.padding_top, 'bottom');
    return padding;
  }

  get isFullWidth() {
    return this.props.item.width === 'full_screen';
  }

  get innerpadding() {
    if (this.isFullWidth) return 'px-0 sm:px-6'
    return "py-8";
  }

  get constrained(){
    const { size, width } = this.props.item;
    return width === "boxed" && size === "constrained";
  }

  get contentAlignment(){
    const { content_alignment, alignment } = this.props.item;
    if (this.constrained && alignment === "center"){
      return content_alignment === "left" ? "justify-start" : content_alignment === "right" ? "justify-end" : "justify-center";
    }
    return "justify-center";
  }

  get isTwoColumn(){
    return this.props.item.alignment === "justified";
  }

  get layout(){
    if (this.isTwoColumn) return "flex-col md:flex-row items-center";
    return "flex-col"
  }

  render() {
    const moduleData: { [key: string]: any } = {
      title: getLanguageField(this.props?.item?.translations, this.props?.selectedLanguage, "title"),
      subtitle: !this.isTwoColumn ? getLanguageField(this.props?.item?.translations, this.props?.selectedLanguage, "subtitle") : "",
      description: !this.isTwoColumn ?  getLanguageField(this.props?.item?.translations, this.props?.selectedLanguage, "body", true, true) : "",
      backgroundImage: this.props.item.image?.imageFile,
      type: this.props.item.type,
      alignment: this.isTwoColumn ? "left" : this.props?.item?.content_alignment || "center",
      bodyColor: this.props?.item?.body_color?.value,
      backgroundColor: this.props?.item?.background_color?.value,
      titleColor: this.props?.item?.title_color?.value,
      subtitleColor: this.props?.item?.subtitle_color?.value,
      imagePosition: this.props?.item?.image_position || "center",
      overlay: this.props?.item?.overlay,
      rounded: this.props.item.rounded_corners,
    };

    const wrapperClassName = this.contentAlignment;
    const roundedStyles = moduleData.rounded ? "rounded-2xl overflow-hidden" : "";
    const justifyButtons = this.contentAlignment

    return (
      <div className={`w-full h-full flex flex-col justify-center gap-4 max-w-7xl mx-auto ${this.innerpadding} ${roundedStyles} relative z-0`} >
        <div
          className={`w-full text-center ${wrapperClassName} flex ${this.layout}`}
        >
          <div className="flex-1">
            <ModuleHeadV2
              title={moduleData.title}
              subtitle={moduleData.subtitle}
              description={moduleData.description}
              color_title={moduleData.titleColor}
              color_subtitle={moduleData.subtitleColor}
              color_description={moduleData.bodyColor}
              remove_margin={this.isTwoColumn}
              align_lists
              alignment={moduleData.alignment === "center" ? "text-center": moduleData.alignment === "left" ? "text-left": "text-right"}
            />
          </div>
          <div className={`w-[80px] lg:w-[240px] h-[1px] hidden md:flex flex-shrink-0`} />
          <div className={`w-full md:w-auto flex flex-col md:flex-row gap-4 items-end ${justifyButtons}`}>
            { this.props.item.primary_cta ? <CTAButtonV2
              className="w-full md:w-auto flex-shrink-0"
              language={this.props.selectedLanguage}
              defaultLanguage={this.props.defaultLanguage}
              ctabutton={this.props.item.primary_cta} /> : null }
            { this.props.item.secondary_cta ? <CTAButtonV2
              className="w-full md:w-auto flex-shrink-0"
              language={this.props.selectedLanguage}
              defaultLanguage={this.props.defaultLanguage}
              ctabutton={this.props.item.secondary_cta} /> : null }
            { this.props.item.soft_cta ? <CTAButtonV2
              className="w-full md:w-auto"
              language={this.props.selectedLanguage}
              defaultLanguage={this.props.defaultLanguage}
              ctabutton={this.props.item.soft_cta} /> : null }
          </div>
        </div>
      </div>
    );
  }
}
